import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  packages: [],
  allPackages: [],
  addPackageData: [],
};

export const PackagesSlice = createSlice({
  name: "packages",
  initialState,
  reducers: {
    getPackagesAction: (state, action) => {
      
      state.allPackages = action.payload;
    },
    getAddPackageDataAction: (state, action) => {
      
      state.addPackageData = action.payload;
    },
    getSinglePackageAction: (state, action) => {
      
      state.packages = action.payload;
    },
  },
});

export default PackagesSlice.reducer;

export const { getPackagesAction, getSinglePackageAction, getAddPackageDataAction } = PackagesSlice.actions;
